import { render, staticRenderFns } from "./selectGoodsList.vue?vue&type=template&id=51312e06&scoped=true&"
import script from "./selectGoodsList.vue?vue&type=script&lang=js&"
export * from "./selectGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./selectGoodsList.vue?vue&type=style&index=0&id=51312e06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51312e06",
  null
  
)

export default component.exports